var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBusket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1667 13.1667C12.2462 13.1667 11.5 13.9129 11.5 14.8333C11.5 15.7538 12.2462 16.5 13.1667 16.5C14.0871 16.5 14.8333 15.7538 14.8333 14.8333C14.8333 13.9129 14.0871 13.1667 13.1667 13.1667ZM13.1667 13.1667H6.74495C6.36058 13.1667 6.16831 13.1667 6.01009 13.0983C5.87055 13.038 5.74945 12.9407 5.66124 12.8168C5.56124 12.6765 5.52174 12.4886 5.44121 12.1127L3.3929 2.55398C3.31237 2.17813 3.27156 1.99021 3.17155 1.84983C3.08335 1.72602 2.96271 1.62868 2.82316 1.56837C2.66495 1.5 2.47316 1.5 2.08878 1.5H1.5M4 4H14.7277C15.3292 4 15.6298 4 15.8316 4.1253C16.0085 4.23505 16.1376 4.40698 16.1941 4.6073C16.2585 4.83599 16.1759 5.12497 16.0092 5.70288L14.8553 9.70288C14.7556 10.0484 14.7058 10.2212 14.6047 10.3494C14.5154 10.4626 14.3977 10.5506 14.2642 10.605C14.113 10.6666 13.9332 10.6667 13.5736 10.6667H5.44206M5.66667 16.5C4.74619 16.5 4 15.7538 4 14.8333C4 13.9129 4.74619 13.1667 5.66667 13.1667C6.58714 13.1667 7.33333 13.9129 7.33333 14.8333C7.33333 15.7538 6.58714 16.5 5.66667 16.5Z",
    stroke: "#272727",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusket);
export default __webpack_public_path__ + "static/media/busket.acd36db8bbf780956b3717ee377cda32.svg";
export { ForwardRef as ReactComponent };